import helpers from './helpers';

class Currency {
  constructor(fee) {
    const { amount = 0, currency = 'HKD', minor = 2 } =
      typeof fee === 'number' ? { amount: fee * 100, minor: 2 } : fee || {};
    this.amount = amount;
    this.currency = currency;
    this.minor = minor;
  }

  add(fee) {
    const { amount } = fee || {};

    if (amount) {
      this.amount += amount;
    }

    return this;
  }

  subtract(fee) {
    const { amount } = fee || {};

    if (amount) {
      this.amount -= amount;
    }

    return this;
  }

  multiply(number, useRounding = true) {
    if (number !== null) {
      const target = this.amount * number;
      this.amount = useRounding ? Math.round(target) : Math.floor(target);
    }

    return this;
  }

  divide(number, useRounding = true) {
    if (number !== null) {
      const target = this.amount / number;
      this.amount = useRounding ? Math.round(target) : Math.floor(target);
    }

    return this;
  }

  format(round = false, priceOnly = false) {
    const locale = helpers.getCurrentLocale(true);
    let value = (this.amount / 10 ** this.minor).toFixed(this.minor);

    if (!priceOnly) {
      value = new Intl.NumberFormat(locale, {
        currencyDisplay: 'code',
        currency: this.currency,
        style: 'currency',
        minimumFractionDigits: round ? 0 : this.minor,
        maximumFractionDigits: round ? 0 : this.minor
      }).format(value);
    }

    return value;
  }

  getDiffPercent({ amount: newAmount }) {
    if (!this.amount || this.amount < newAmount) return null;
    const percent = Math.round((1 - newAmount / this.amount) * 100, 0); // TODO: more accurate to use floor()?
    return `${percent}%`;
  }
}

export default Currency;
